// import commonBiz from '../../domain/common/commonBiz';
export default class CallParser {
    static process(clientStater, callMsg) {
        if (clientStater.opts.oncall) {
            clientStater.opts.oncall({ code: 200, data: callMsg });
        }
    }
    static processOpt(clientStater, callMsgOpt) {
        if (clientStater.opts.oncallopt) {
            clientStater.opts.oncallopt({ code: 200, data: callMsgOpt });
        }
    }
}
//# sourceMappingURL=callParser.js.map